import { render, staticRenderFns } from "./FlawOnMap.vue?vue&type=template&id=5429d8e6&scoped=true"
import script from "./FlawOnMap.vue?vue&type=script&lang=js"
export * from "./FlawOnMap.vue?vue&type=script&lang=js"
import style0 from "./FlawOnMap.vue?vue&type=style&index=0&id=5429d8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5429d8e6",
  null
  
)

export default component.exports